/**
 * Timing constants for CollapsibleToolbar animations
 * Centralized to avoid magic numbers and improve maintainability
 */
export const TIMING = {
	/** Collapse animation duration */
	COLLAPSE_MS: 400,
	/** Expand animation duration (barExpand 0.5s + last cascade delay) */
	EXPAND_MS: 650,
	/** Bar expand/collapse animation duration */
	BAR_EXPAND_MS: 500,
	/** Slide in/out animation duration */
	SLIDE_MS: 400,
	/** Slide out animation duration */
	SLIDE_OUT_MS: 300,
	/** Button fade animation duration */
	BUTTON_FADE_MS: 300,
	/** Base delay before items start appearing (15% of bar expansion) */
	BASE_DELAY_MS: 75, // BAR_EXPAND_MS * 0.15
	/** Stagger delay between items on expand */
	STAGGER_MS: 30,
	/** Stagger delay between items on collapse */
	COLLAPSE_STAGGER_MS: 20,
	/** Maximum expected items (for collapse delay calculation) */
	MAX_ITEMS: 10,
} as const
